import { computed, getCurrentInstance } from '@vue/composition-api'

export const useReporting = () => {
  const vm = getCurrentInstance()
  const store = vm.proxy.$store

  const downloadMultipleReports = (payload) => store.dispatch('reporting/DOWNLOAD_MULTIPLE_REPORTS', payload)
  const downloadReport = (payload) => store.dispatch('reporting/DOWNLOAD_REPORT', payload)
  const generatingReport = computed(() => store.getters['generatingReport'])
  const handleFileDownload = ({ reportId, type, fileName, invoiceType, downloadKey, dateOfService, groupCk,subGroupCk }) => {
    if (!reportIsDownloading.value(reportId)) {
      downloadReport({ reportId, type, fileName, invoiceType, downloadKey, dateOfService, groupCk, subGroupCk })
    }
  }
  const handleMultipleFileDownload = ({ invoiceType, year, month, status, fileName }) => {
    return downloadMultipleReports({ invoiceType, year, month, status, fileName })
  }
  const multipleReportsIsDownloading = computed(() => store.getters['reporting/multipleReportsIsDownloading'])
  const multipleReportsDownloading = computed(() => store.getters['reporting/multipleReportsDownloading'])
  const reportingStatus = computed(() => store.getters['reporting/reportingStatus'])
  const reportingUserMessage = computed(() => store.getters['reporting/reportingUserMessage'])
  const reportIsDownloading = computed(() => (reportId) => {
    return store.getters['reporting/reportIsDownloading'](reportId)
  })
  const reportNavCategories = computed(() => store.getters['reporting/reportNavCategories'])
  const reportProcessed = computed(() => store.getters['reporting/reportProcessed'])
  const reportTypes = computed(() => store.getters['reporting/reportTypes'])
  const reportsDownloading = computed(() => store.getters['reporting/reportsDownloading'])
  const reportsHaveLoaded = computed(() => store.getters['reporting/reportsHaveLoaded'])
  const reportsLoading = computed(() => store.getters['reporting/reportsLoading'])
  const reportsToShow = computed(() => store.getters['reporting/reportsToShow'])
  const selectedReportType = computed(() => store.getters['selectedReportType'])

  return {
    downloadMultipleReports,
    downloadReport,
    generatingReport,
    handleFileDownload,
    handleMultipleFileDownload,
    multipleReportsIsDownloading,
    multipleReportsDownloading,
    reportingStatus,
    reportingUserMessage,
    reportIsDownloading,
    reportNavCategories,
    reportProcessed,
    reportTypes,
    reportsDownloading,
    reportsHaveLoaded,
    reportsLoading,
    reportsToShow,
    selectedReportType
  }
}
